import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "new-customer-page" }

import { ref, onBeforeMount, inject } from "vue";
import { set } from "@vueuse/core";
import Form from "../common/form.vue";
import rulesFn from "../common/rules";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const clinicId = ref(0);

onBeforeMount(async () => {
  await set(clinicId, await inject("clinicId"));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Form, {
      clinicId: clinicId.value,
      rules: _unref(rulesFn)(false)
    }, null, 8, ["clinicId", "rules"])
  ]))
}
}

})